export const fullAddress = (addressFirst?: string | null, addressSecond?: string | null): string =>
  [addressFirst, addressSecond ?? ''].filter(Boolean).join(', ');

export const cityZip = (
  addressCity?: string | null,
  abbreviation?: string | null,
  addressZip?: string | null,
): string => {
  const cityState = [addressCity, abbreviation].filter(Boolean).join(', ');
  return `${cityState} ${addressZip}`;
};

export const couldShowFlexibleDates = (status: string, flexibleStartsDate: boolean): boolean => {
  if (['w2_onboarding', 'booked', 'in_progress'].includes(status)) {
    return false;
  }
  return flexibleStartsDate;
};
